import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Payable } from 'services/action';
import { Button, Modal } from 'react-bootstrap';

import { Uploader } from 'ui/components';
import pdf from 'ui/assets/pdf.png';
import xlsx from 'ui/assets/xlsx.png';

const initialState = {
  attachments: [],
};

export const FormPartial = ({ data, updateType, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ attachments }, setState] =
    React.useState(initialState);

  const $postImage = async(e) => {
    setState((prevState) => ({...prevState, attachments: [...attachments, ...e]}));
  }

  const handleSubmit = async (e) => {
    const payload = {
      attachments: attachments,
    };

    let req = null
    if (data) {
      req = await Dispatch(Payable.$updatePartial(data?.id, payload));
    }

    if (req?.message === 'success') {
      onClose();
    }
  };

  React.useEffect(() => {
    if (!data) return

    setState((prevState) => ({
      ...prevState,
      attachments: data?.attachments || [],
    }));

  }, [data])

  return (
    <>
      <Modal.Body>
        <div className="row text-start">
          <div className="col-md-12">
            <label className="form-label ">Attachments</label>
            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-around pt-2">
              <Uploader
                medium
                setData={(e) => $postImage(e)}
              />
              {attachments?.map((d, i) => (
                <div key={i} style={{ width: 100, height: 100 }}>
                  <img className="img-hover rounded-3" src={`${d?.includes('.pdf') ? pdf : d?.includes('.xlsx') ? xlsx : d}`} alt="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button variant="white" className="w-100" onClick={onClose}>
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              variant="primary"
              className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
              onClick={handleSubmit}
              disabled={StateForm?.loading}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
